// General
import "./popular-tab.scss";
import { useEffect } from "react";
// Services
import { useLazyGetProductGiftsQuery } from "../../../../../services/data.service";
// Static Data
import routeConst from "../../../../../const/routeConst";
// Custom Hooks
import useCustomNavigate from "../../../../utility/custom-hooks/useCustomNavigate-hook";
// Components
import Spinner from "../../../elements/spinner/spinner";
import Gifts from "../../../elements/gifts/gifts";

const PopularTab = () => {
  // API variables
  const [
    getProductGifts,
    {
      data: getProductGiftsData,
      error: getProductGiftsErrorData,
      isFetching: getProductGiftsFetching,
      isLoading: getProductGiftsLoading,
      isSuccess: getProductGiftsSuccess,
      isError: getProductGiftsError,
    },
  ] = useLazyGetProductGiftsQuery();

  // Render variables
  let giftsListView;

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    getProductGifts(null, true);
  }, []);

  // Render Functions | Loading
  if (getProductGiftsFetching || getProductGiftsLoading) {
    giftsListView = <Spinner />;
  } else if (getProductGiftsError) {
    if (getProductGiftsErrorData?.status === 401) {
      // onNavigate(routeConst.logout.path);
    }
  }

  // Render Functions | Success
  if (getProductGiftsData?.data?.length > 0) {
    giftsListView = getProductGiftsData?.data?.map((gift, index) => {
      if (gift?.categories.includes("popular")) {
        return (
          <Gifts
            state={"livestream"}
            productHashId={gift?.product_hash_id}
            giftImage={gift?.graphics?.png}
            giftAmount={gift?.amount.toLocaleString()}
            isEventBased={gift?.is_event_based}
            key={index}
          />
        );
      }
    });
  }

  return (
    <div id="product-purchase-dialog-popular-tab-subcomponent">
      {giftsListView}
    </div>
  );
};

export default PopularTab;
